/** Athlete-facing labels — never expose internal rule keys (B1, M4, etc.). */

const CONSUMER_LABELS: Record<string, string> = {
  M1: 'Basal Metric: Lean Mass Formulation',
  M2: 'Energy Load: Training Volume Alignment',
  M3: 'Fuel Floor: Minimum Daily Energy Guard',
  M4: 'Protein Target: Muscle Recovery Support',
  M5: 'Carbohydrate Periodisation',
  M6: 'Fat Intake Balance',
  M7: 'Hydration & Electrolyte Baseline',
  M8: 'Meal Timing Window',
  M9: 'Nutrient Density Priority',
  M10: 'Macro Distribution Optimisation',
  K1: 'Load Ratio: Acute vs Chronic Balance',
  K2: 'Recovery Signal: HRV Baseline Drift',
  K3: 'Sleep Debt Compensation',
  K4: 'Training Volume Autoregulation',
  K5: 'Recovery Debt Accumulation',
  K6: 'Stress–Recovery Balance',
  I1: 'Joint Protection: Impact Modification',
  I2: 'Movement Substitution: Injury-Safe Swap',
  I3: 'Tissue Tolerance: Load Cap',
  I4: 'Patellar Tendon: Isometric Support',
  I5: 'Shoulder Complex: Press Modification',
  I6: 'Low-Impact Cardio Alternative',
  B1: 'Coaching Tone: Recovery Support',
  B2: 'Pre-Session Nervous System Reset',
  P1: 'Predictive Recovery: HRV Trend',
  P2: 'Predictive Recovery: Debt Deload',
  P3: 'Calendar Load: Pre-Event Management',
  C1: 'Cycle Awareness: Symptom-Informed Training',
  C2: 'Luteal Phase: Carbohydrate Availability',
  C3: 'Late Luteal: Satiety & Magnesium Support',
  K7: 'Cycle Phase: Volume Autoregulation',
}

const INTERNAL_ACTION_PATTERNS = [
  /^use empathetic coach tone\.?$/i,
  /^compute bmr via katch-mcardle.*$/i,
  /^apply activity multiplier.*$/i,
  /^enforce minimum \d+ kcal.*$/i,
  /^set protein at [\d.]+ g\/kg.*$/i,
]

export function consumerEvidenceLabel(ruleKey: string, fallbackSummary?: string): string {
  return CONSUMER_LABELS[ruleKey] ?? sanitizeEvidenceAction(fallbackSummary ?? 'Performance insight applied')
}

export function sanitizeEvidenceAction(action: string): string {
  const trimmed = action.trim()
  for (const pattern of INTERNAL_ACTION_PATTERNS) {
    if (pattern.test(trimmed)) {
      return CONSUMER_LABELS.B1 ?? 'Coaching adjustment applied for your recovery context'
    }
  }
  return trimmed.replace(/^[A-Z]\d+\s*[•:·\-]\s*/i, '').trim() || 'Performance insight applied'
}

export function shouldHideRuleKey(_ruleKey: string): boolean {
  return true
}
